import axios from "axios";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { refreshTokenApi } from "../apiCalls/Apicalls";

const AUTH_COOKIE_NAMES = ["jwtToken", "userEmail", "access", "refreshToken"];

export const getCookieConfig = (redirectDomain) => {
  const currentDomain = window.location.hostname;
  return {
    domain:
      redirectDomain || currentDomain || process.env.REACT_APP_COOKIES_DOMAIN,
    path: "/",
  };
};

export const clearAuthCookies = (redirectDomain) => {
  const currentDomain = window.location.hostname;
  const configuredDomain = process.env.REACT_APP_COOKIES_DOMAIN;
  const domains = [redirectDomain, currentDomain, configuredDomain].filter(Boolean);

  AUTH_COOKIE_NAMES.forEach((cookieName) => {
    Cookies.remove(cookieName, { path: "/" });
    domains.forEach((domain) => {
      Cookies.remove(cookieName, { domain, path: "/" });
    });
  });
};

export const persistAuthSession = ({
  jwtToken,
  userEmail,
  access,
  refreshToken,
  redirectDomain,
}) => {
  const cookieConfig = getCookieConfig(redirectDomain);

  Cookies.set("jwtToken", jwtToken, cookieConfig);
  Cookies.set("userEmail", userEmail, cookieConfig);
  Cookies.set("access", JSON.stringify(access || []), cookieConfig);

  if (refreshToken) {
    Cookies.set("refreshToken", refreshToken, cookieConfig);
  }
};

export const getUserFromToken = () => {
  const token = Cookies.get("jwtToken");
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch (error) {
    console.error("Invalid token:", error);
    return null;
  }
};

export const isTokenExpiringSoon = (token, thresholdSeconds = 300) => {
  if (!token) {
    return true;
  }

  try {
    const decoded = jwtDecode(token);
    if (!decoded?.exp) {
      return true;
    }
    const expiresAtMs = decoded.exp * 1000;
    return expiresAtMs - Date.now() <= thresholdSeconds * 1000;
  } catch (error) {
    return true;
  }
};

export const refreshAuthSession = async ({
  redirectDomain,
  refreshToken,
} = {}) => {
  const storedRefreshToken = refreshToken || Cookies.get("refreshToken");
  if (!storedRefreshToken) {
    return null;
  }

  const response = await axios.post(
    refreshTokenApi,
    { refresh_token: storedRefreshToken },
    { withCredentials: true },
  );

  persistAuthSession({
    jwtToken: response.data.jwt_token,
    userEmail: response.data.userEmail,
    access: response.data.access,
    refreshToken: response.data.refresh_token,
    redirectDomain,
  });

  return response.data;
};
